import { useAtom } from "jotai";
import type { IProductRequisitesStore } from "../../stores/productRequisites/productRequisites.store";
import { productRequisitesStore } from "../../stores/productRequisites/productRequisites.store";

export interface IUseProductRequisites {
  productRequisites: IProductRequisitesStore | null;
  setProductRequisites: (productRequisites: IProductRequisitesStore | null) => void;
  clearProductRequisites: () => void;
}

export function useProductRequisites(): IUseProductRequisites {
  const [productRequisites, setProductRequisites] = useAtom(productRequisitesStore);

  function clearProductRequisites() {
    setProductRequisites(null);
  }

  return {
    productRequisites,
    setProductRequisites,
    clearProductRequisites,
  };
}
